import _classCallCheck from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/classCallCheck.js";
import _createClass from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/createClass.js";
import _inherits from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/inherits.js";
import _possibleConstructorReturn from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn.js";
import _getPrototypeOf from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/getPrototypeOf.js";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import BaseSchema from './schema';
import { boolean as locale } from './locale';
import isAbsent from './util/isAbsent';
export function create() {
  return new BooleanSchema();
}

var BooleanSchema = /*#__PURE__*/function (_BaseSchema) {
  _inherits(BooleanSchema, _BaseSchema);

  var _super = _createSuper(BooleanSchema);

  function BooleanSchema() {
    var _this;

    _classCallCheck(this, BooleanSchema);

    _this = _super.call(this, {
      type: 'boolean'
    });

    _this.withMutation(function () {
      _this.transform(function (value) {
        if (!this.isType(value)) {
          if (/^(true|1)$/i.test(String(value))) return true;
          if (/^(false|0)$/i.test(String(value))) return false;
        }

        return value;
      });
    });

    return _this;
  }

  _createClass(BooleanSchema, [{
    key: "_typeCheck",
    value: function _typeCheck(v) {
      if (v instanceof Boolean) v = v.valueOf();
      return typeof v === 'boolean';
    }
  }, {
    key: "isTrue",
    value: function isTrue() {
      var message = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : locale.isValue;
      return this.test({
        message: message,
        name: 'is-value',
        exclusive: true,
        params: {
          value: 'true'
        },
        test: function test(value) {
          return isAbsent(value) || value === true;
        }
      });
    }
  }, {
    key: "isFalse",
    value: function isFalse() {
      var message = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : locale.isValue;
      return this.test({
        message: message,
        name: 'is-value',
        exclusive: true,
        params: {
          value: 'false'
        },
        test: function test(value) {
          return isAbsent(value) || value === false;
        }
      });
    }
  }]);

  return BooleanSchema;
}(BaseSchema);

export { BooleanSchema as default };
create.prototype = BooleanSchema.prototype;